import { useEffect, useState } from 'react';

/** 入力が止まってから値を返す（1文字ごとに検索を投げないため）。 */
export default function useDebouncedValue(value, ms = 300) {
  const [out, setOut] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setOut(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return out;
}
